import { mergeWith } from 'lodash'
import * as moment from 'moment'

export const XSRF_REQUEST_HEADER = () => {
  const csrfToken = document.head.querySelector('[name~=csrf-token][content]').content
  return {
    'X-CSRF-Token': csrfToken
  }
}
export const JSON_REQUEST_HEADER = () => {
  return {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    ...XSRF_REQUEST_HEADER()
  }
}

export const createRequest = async (URL, header, bodyData = {}, options = {}) => {
  let headerMerged = mergeWith(JSON_REQUEST_HEADER(), header)
  let response

  // Ensure absolute path using base-url meta tag if available
  let path = URL.path
  const baseUrlMeta = document.head.querySelector('[name~=base-url][content]')
  if (baseUrlMeta && !path.startsWith('http') && !path.startsWith('/')) {
    const baseUrl = baseUrlMeta.content.replace(/\/$/, '')
    if (!path.startsWith('app/') && !path.startsWith('api/')) {
      path = `app/${path}`
    }
    path = `${baseUrl}/${path}`
  }

  const fetchOptions = {
    headers: headerMerged,
    ...options
  }

  switch (URL.method) {
    case 'GET':
      response = await fetch(path, fetchOptions)
      return response.json()

    case 'POST':
    case 'PUT':
    case 'PATCH':
      fetchOptions.method = URL.method
      fetchOptions.body = JSON.stringify(bodyData)
      response = await fetch(path, fetchOptions)
      return response.json()

    case 'DELETE':
      fetchOptions.method = 'DELETE'
      response = await fetch(path, fetchOptions)
      return response.json()

    default:
      break
  }
  return false
}

export const createRequestWithFormData = async (URL, header, bodyData, options = {}) => {
  let headerMerged = mergeWith(XSRF_REQUEST_HEADER(), header)
  let response

  // Ensure absolute path using base-url meta tag if available
  let path = URL.path
  const baseUrlMeta = document.head.querySelector('[name~=base-url][content]')
  if (baseUrlMeta && !path.startsWith('http') && !path.startsWith('/')) {
    const baseUrl = baseUrlMeta.content.replace(/\/$/, '')
    if (!path.startsWith('app/') && !path.startsWith('api/')) {
      path = `app/${path}`
    }
    path = `${baseUrl}/${path}`
  }

  switch (URL.method) {
    case 'POST':
    case 'PUT':
    case 'PATCH':
      try {
        response = await fetch(path, {
          method: URL.method,
          headers: headerMerged,
          body: bodyData,
          ...options
        })
        const text = await response.text()
        let data = {}
        if (text) {
          try {
            data = JSON.parse(text)
          } catch {
            if (!response.ok) {
              data = {
                message:
                  response.status === 413
                    ? 'The uploaded file is too large for the server. Use a smaller image or ask your host to raise upload limits (PHP post_max_size / upload_max_filesize).'
                    : text.slice(0, 300) || response.statusText
              }
            }
          }
        }
        if (!response.ok) {
          return {
            status: false,
            message: data.message || `Request failed (${response.status})`,
            all_message: data.errors || data.all_message || {}
          }
        }
        return data
      } catch (e) {
        return {
          status: false,
          message: e.message || 'Network error',
          all_message: {}
        }
      }
      break
  }
}

export const readFile = (file, callback) => {
  let reader = new FileReader()
  reader.addEventListener('load', () => {
    callback(reader.result)
  })
  reader.readAsDataURL(file)
}

export const buildMultiSelectObject = (arr, { value, label }) => {
  if (!Array.isArray(arr)) {
    console.warn('buildMultiSelectObject: Expected array, received:', typeof arr, arr)
    return []
  }
  return arr.map((item) => {
    return { value: item[value], label: item[label] }
  })
}

export const startTime = (value) => {
  return moment(value).format('YYYY-MM-DDTHH:mm')
}

export const endTime = (value, addTime) => {
  return moment(value).add(addTime, 'minutes').format('YYYY-MM-DDTHH:mm')
}

export const confirmSwal = async ({ title }) => {
  return await Swal.fire({
    title: title,
    icon: 'warning',
    // Ensure it stacks above any booking modals/offcanvas backdrops.
    zIndex: 3000,
    showCancelButton: true,
    confirmButtonColor: '#d33', // Red for delete button
    cancelButtonColor: '#858482',
    cancelButtonText: 'Cancel',
    confirmButtonText: 'Yes, delete it!',
    showClass: {
      popup: 'animate__animated animate__zoomIn'
    },
    hideClass: {
      popup: 'animate__animated animate__zoomOut'
    }
  }).then((result) => {
    return result
  })
}

export const confirmcancleSwal = async ({ title }) => {
  return await Swal.fire({
    title: title,
    icon: 'question',
    // Booking calendar uses custom modal z-index (and sometimes removes default stacking),
    // so we force SweetAlert to be above both offcanvas + modal backdrops.
    zIndex: 3000,
    showCancelButton: true,
    confirmButtonColor: '#d33',
    cancelButtonColor: '#858482',
    confirmButtonText: 'Yes, do it!',
    showClass: {
      popup: 'animate__animated animate__zoomIn'
    },
    hideClass: {
      popup: 'animate__animated animate__zoomOut'
    }
  }).then((result) => {
    return result
  })
}
